const Header = ({title}) => {
    return (
        <div className="app-header">
            <h1>{title}</h1>
        </div>
    )
    
}

export default Header;